<template>
    <div class="container-fluid about-section" >
        <div class="container center-piece">
            <div class="row">
                <div class="col">
                    <h2 class="about-solidarity-title">About the Solidarity Fund</h2>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="about-solidarity">
                        "Thuma Mina" means "send me" - the COVID-19 pandemic is the most definitive "Thuma Mina" moment
                        for our country. Never before in the history of our democracy has our country been confronted by such a severe
                        situation; but, it is a situation which we will be able to overcome if we work together.
                        DPO South Africa will redirect all money collected here, to the Solidarity Fund.
                        Find out more about the fund here: <a class="solidarity-link" target="_blank" href="https://www.solidarityfund.co.za/">Solidarity Fund</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'CenterPiece'
  }
</script>

